export const LISTE_AUDIT = {
  title: 'Liste des audits techniques',
  breadcrumb: {
    liste: 'Liste audits techniques',
  },
  etat: {
    enCours: 'En cours',
    planifie: 'Planifié',
    realise: 'Réalisé',
    clos: 'Clos',
  },
  actions: {
    add: 'Nouvel audit technique',
    realise: 'Réaliser',
    enCours: 'En cours',
    planifie: 'Planifier',
    cloturer: 'Clôturer',
  },
  tabs: {
    code: 'Code',
    etat: 'Etat',
    dateSouhaite: 'Date souhaitée',
    datePlanification: 'Date de planification',
    dateRealisation: 'Date de réalisation',
    auditeur: 'Auditeur',
    agence: 'Agence',
    nbDispositif: 'Nb dispositifs',
    titre: 'Titre',
  },
  filtre: {
    code: 'Code(s)',
    etat: 'Etat(s)',
    agence: 'Agence(s)',
    dateSouhaite: 'Date souhaitée',
    datePlanification: 'Date de planification',
    dateRealisation: 'Date de réalisation',
    auditeur: 'Auditeur(s)',
    titre: 'Titre(s)',
    error: {
      dates: 'La date de début du filtre par date souhaitée est plus grande que sa date de fin',
      datesPremierAffichage: 'La date de début du filtre par date de planification est plus grande que sa date de fin',
      datesValidite: 'La date de début du filtre par date de réalisation est plus grande que sa date de fin',
    },
  },
  actionPopUp: {
    realiserAudit: 'Êtes-vous sûr de vouloir réaliser vos audits ?',
    encoursAudit: 'Êtes-vous sûr de vouloir passer à l\'état "En cours" vos audits ?',
    planifierAudit: 'Êtes-vous sûr de vouloir planifer vos audits ?',
    supprimerAuditMulti: 'Êtes-vous sûr de vouloir supprimer vos audits ?',
    supprimerAudit: 'Êtes-vous sûr de vouloir supprimer votre audit ?',
    cloturerAuditMulti: 'Êtes-vous sûr de vouloir clôturer vos audits ?',
    errors: {
      auditShouldBeAchieve: 'L\'audit technique "{code}" doit être à l\'état "Réalisé"',
      auditShouldBeClosed: 'L\'audit technique "{code}" doit être à l\'état "Clos"',
    },
  },
  messages: {
    success: {
      delete: 'Audit(s) supprimé(s) avec succès.',
      updateEtat: 'Etat audit(s) modifié avec succès.',
      auditCloturer: 'Audit(s) clôturé(s) avec succès.',
    },
  },
};

export const DETAIL_AUDIT = {
  title: 'Détail audit technique {code}',
  breadcrumb: {
    liste: 'Liste audits techniques',
    detail: 'Détail audit technique',
  },
  actions: {
    realise: 'Réaliser',
    enCours: 'En cours',
    planifie: 'Planifier',
    clos: 'Clôturer',
    decloturer: 'Déclôturer',
    applyMatPicsToFaces: 'Synchroniser les photos sur le catalogue',
  },
  onglet: {
    audit: 'Audit',
    patrimoine: 'Patrimoine',
  },
  popup: {
    msgPlanifier: 'Êtes-vous sûr de vouloir planifier votre audit ?',
    msgEncours: 'Êtes-vous sûr de vouloir mettre à l\'état "en cours" audit ?',
    msgRealiser: 'Êtes-vous sûr de vouloir réaliser votre ordre de travail ?',
    datePlanification: 'Date de planification',
    dateRealisation: 'Date de réalisation',
    cloturerAudit: 'Êtes-vous sûr de vouloir clôturer votre audit ?',
    decloturerAudit: 'Êtes-vous sûr de vouloir déclôturer votre audit ?',
    syncMatPicsToFaces: 'Êtes-vous sûr de vouloir synchroniser les photos des matériels avec leurs produits ?',
  },
  infoGenerale: {
    title: 'Informations générales',
    dateSouhaite: 'Date souhaitée :',
    datePlanification: 'Date de planification :',
    dateRealisation: 'Date de réalisation :',
    auditeur: 'Auditeur :',
    description: 'Description :',
    agence: 'Agence :',
    titre: 'Titre :',
    pj: 'Pièces-jointes',
  },
  dispositif: {
    title: 'Dispositifs associés',
    aucunDispositif: 'Aucun dispositif n\'a été associé',
    actions: {
      search: 'Rechercher par code',
    },
  },
  messages: {
    success: {
      delete: 'Audit supprimé avec succès.',
      updateEtat: 'Etat audit modifié avec succès.',
      cloturer: 'Audit clôturé avec succès.',
      reactiver: 'Audit déclôturé avec succès.',
      syncMatPicsToFaces: 'La synchronisation a été faite avec succèes',
    },
    error: {
      auditShouldBeAchieve: 'L\'audit technique doit être à l\'etat "Réalisé"',
      auditShouldBeClosed: 'L\'audit technique doit être à l\'etat "Clos"',
    },
  },
};

export const ADD_EDIT_AUDIT = {
  title: {
    add: 'Ajouter un audit technique',
    edit: 'Modifier l\'audit technique {code}',
    addDispositif: 'Ajouter des dispositifs à votre audit',
    addReseau: 'Ajouter des réseaux à votre audit',
  },
  breadcrumb: {
    liste: 'Liste audits techniques',
    add: 'Ajouter audit technique',
    edit: 'Modifier audit technique',
    addDispositif: 'Ajouter dispostif',
    addReseau: 'Ajouter réseau',
  },
  onglet: {
    audit: 'Audit',
    patrimoine: 'Patrimoine',
  },
  infoGenerale: {
    title: 'Informations générales',
    dateSouhaite: 'Date souhaitée',
    datePlanification: 'Date de planification',
    dateRealisation: 'Date de réalisation',
    auditeur: 'Auditeur',
    description: 'Description',
    agence: 'Agence',
    titre: 'Titre',
    pj: 'Pièces-jointes',
  },
  dispositif: {
    title: 'Dispositifs associés',
    aucunDispositif: 'Aucun dispositif n\'a été associé',
    addDispositif: 'Ajouter un dispositif pour l\'associer à l\'audit',
    successAdd: 'Dispositif ajouté avec succès',
    actions: {
      search: 'Rechercher par code',
      associer: 'Associer un dispositif ou un réseau',
      addDispositifMultiple: 'Ajouter des dispositifs',
      addReseauMultiple: 'Ajouter des réseaux',
    },
    group: {
      reseau: 'Réseaux',
      dispositif: 'Dispositifs',
    },
  },
  messages: {
    success: {
      create: 'Audit technique créé avec succès.',
      update: 'Audit technique modifié avec succès.',
    },
    error: {
      technicWorkOrdreProduct: 'La société ne contient pas de produit d\'OT technique',
      auditNeedDatePlanifMulti: 'Pour passer à l\'état "Planifié", les audits technique {code} doivent avoir une date de planification renseignée',
      auditNeedDateRealisationMulti: 'Pour passer à l\'état "Réalisé", les audits technique {code} doivent avoir une date de réalisée renseignée',
      auditNeedDatePlanif: 'Pour passer à l\'état "Planifié", l\'audit technique {code} doit avoir une date de planification renseignée',
      auditNeedDateRealisation: 'Pour passer à l\'état "Réalisé", l\'audit technique {code} doit avoir une date de réalisée renseignée',
      onePatrimoine: 'Il faut au moins ajouter un dispositif',
      auditeurMissing: 'Le champ "Auditeur" est obligatoire',
      typeIntervention: 'Le type d\'OT audit n\'est pas paramétré dans le société',
    },
  },
};
